module.exports = __webpack_public_path__ + "static/img/hide_status.bc05d54d.png";